import React from 'react';

export const ClienteModal = ({ closeModal, cliente }) => {
  return (
    <div className='modal__backgroundModal'>
        <div className='modal__container'>
            <div className='modal__closeModalXButton'>
                <button onClick={() => closeModal(false)}>X</button>
            </div>
            <div className='modal__header'>
              <h1 className='modal__title'>Detalles del Cliente</h1>
            </div>
            
            <div className='modal__body'>
               <p><b>Nombre o Razón Social:</b> {cliente.nombre}</p>
               {cliente.nombreComercial && (
                   <p><b>Nombre Comercial:</b> {cliente.nombreComercial}</p>
               )}
               <p><b>Dirección:</b> {cliente.direccion}</p>
               <p><b>Municipio:</b> {cliente.municipio}</p>
               <p><b>Tipo de Usuario:</b> {cliente.tipoUsuario}</p>
               <div className='modal__separador'></div>
               
               <p><b>Teléfono:</b> {cliente.telefono || 'S/N'}</p>
               <p><b>Email:</b> {cliente.email || 'S/N'}</p>
               <div className='modal__separador'></div>

               <p><b>Fecha Último Pedido:</b> {cliente.fechaUltimoPedido || 'S/N'}</p>
               <p><b>No. Factura:</b> {cliente.noFactura || 'S/N'}</p>
               <p><b>Frecuencia Pedidos:</b> {cliente.frecuenciaPedidos || 'S/N'}</p>
               <div className='modal__separador'></div>

               <p><b>RFC:</b> {cliente.rfc || 'S/N'}</p>
               <p><b>Dirección Facturación:</b> {cliente.direccionFactura || 'S/N'}</p>
               <p><b>Giro del Cliente:</b> {cliente.giroCliente || 'S/N'}</p>
               <div className='modal__separador'></div>
               <p><b>Registrado por:</b> {cliente.registroPor ? cliente.registroPor.nombre : 'Sistema'}</p>
            </div>
        </div>
    </div>
  )
}
